import { createContext } from 'react';
import {
  type AppLocale,
  LOCALE_LABELS,
  SUPPORTED_LOCALES,
} from '../i18n/config';

export interface LocaleContextValue {
  locale: AppLocale;
  dir: 'ltr' | 'rtl';
  isRtl: boolean;
  labels: typeof LOCALE_LABELS;
  supportedLocales: typeof SUPPORTED_LOCALES;
  ready: boolean;
  setLocale: (locale: AppLocale) => Promise<void>;
  refreshFromApi: () => Promise<void>;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);
